import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
} from "reactstrap"
import API from "../../api/axios"
import { FaRegEyeSlash } from "react-icons/fa6"
import { useNavigate } from "react-router-dom"
import UserForm from "./UserForm"
import { setBreadcrumbItems } from "../../store/actions"
import { connect } from "react-redux"

const DataTable = (props) => {
  const navigate = useNavigate()
  const [userData, setUserData] = useState([])
  const [role, setRole] = useState("admin")

  const breadcrumbItems = [
    { title: "Dashboard", link: "/dashboard" },
    { title: "User", link: "#" },
  ]

  const fetchFilteredData = async (selectedRole) => {
    console.log("Fetching data for role:", selectedRole)
    try {
      const token = localStorage.getItem("authToken")
      const params = {}
      if (role) params.role = role

      const response = await API.get("/users", {
        params,
        headers: { Authorization: `Bearer ${token}` },
      })

      console.log("user fetched", response.data.users)
      props.setBreadcrumbItems("User Table", breadcrumbItems)

      if (response.data && Array.isArray(response.data.users)) {
        setUserData(response.data.users)
      } else {
        console.error("Users data is not an array:", response.data)
      }
    } catch (error) {
      console.error("Error fetching role", error)
    }
  }

  useEffect(() => {
    console.log("useEffect triggered. Role is:", role)
    fetchFilteredData(role)
  }, [role])

  const handleEditClick = (user) => {
    navigate(`/user-profile/${user.id}`, { state: { userData: user } })
  }

  const chunkArray = (arr, chunckSize) => {
    const result = []
    for (let i = 0; i < arr.length; i = i + chunckSize) {
      result.push(arr.slice(i, i + chunckSize))
    }
    return result
  }

  const UserTableData = {
    columns: [
      { label: "First Name", field: "fname", sort: "asc", width: 150 },
      { label: "Last Name", field: "lname", sort: "asc", width: 150 },
      { label: "Phone", field: "phone", sort: "asc", width: 150 },
      { label: "Email", field: "email", sort: "asc", width: 150 },
      { label: "Gender", field: "gender", sort: "asc", width: 100 },
      { label: "Role", field: "role", sort: "asc", width: 100 },
      { label: "Speciality", field: "speciality", sort: "asc", width: 100 },
      { label: "Active Status", field: "isActive", sort: "asc", width: 100 },
      { label: "Action", field: "action", sort: "disabled", width: 100 },
    ],
    rows:
      Array.isArray(userData) && userData.length > 0
        ? userData.map((user) => ({
            fname: user.fname,
            lname: user.lname,
            phone: user.phone,
            email: user.email,
            gender: user.gender,
            role: user.role,
            speciality: user.Services
              ? chunkArray(user.Services, 2).map((pair, i) => (
                  <div key={i} style={{ marginBottom: "4px" }}>
                    {pair.map((s, j) => (
                      <span
                        key={j}
                        style={{
                          backgroundColor: "#3acb54",
                          color: "#000",
                          padding: "2px 6px",
                          borderRadius: "0.25rem",
                          fontSize: "0.75rem",
                          marginRight: "2px",
                          display: "inline-block",
                        }}
                      >
                        {s.name?.replace(/,+$/, "") || "N/A"}
                      </span>
                    ))}
                  </div>
                ))
              : "N/A",
            isActive: user.isActive ? "Active" : "Inactive",
            action: (
              <button
                className="btn btn-success"
                onClick={() => handleEditClick(user)}
              >
                <FaRegEyeSlash size={20} className="text-green-600" />
              </button>
            ),
          }))
        : [],
  }

  return (
    <React.Fragment>
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <CardTitle className="h4">User Datatable</CardTitle>

              <UserForm refresh={fetchFilteredData} />

              {/* Filter Section */}
              <fieldset className="d-flex justify-content-start mb-4">
                <Label className="mr-4">Role:</Label>

                <FormGroup check inline>
                  <Input
                    type="radio"
                    name="role"
                    value="admin"
                    checked={role === "admin"}
                    onClick={() => setRole("admin")}
                  />
                  <Label check>Admin</Label>
                </FormGroup>

                <FormGroup check inline>
                  <Input
                    type="radio"
                    name="role"
                    value="staff"
                    checked={role === "staff"}
                    onClick={() => setRole("staff")}
                  />
                  <Label check>Staff</Label>
                </FormGroup>

                <FormGroup check inline>
                  <Input
                    type="radio"
                    name="role"
                    value="doctor"
                    checked={role === "doctor"}
                    onClick={(e) => setRole(e.target.value)}
                  />
                  <Label check>Doctor</Label>
                </FormGroup>

                <FormGroup check inline>
                  <Input
                    type="radio"
                    name="role"
                    value="all"
                    checked={role === "all"}
                    onClick={() => setRole("all")}
                  />
                  <Label check>All</Label>
                </FormGroup>
              </fieldset>

              <MDBDataTable responsive bordered data={UserTableData} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(DataTable)
